import React from 'react'
import styled, { useTheme } from 'styled-components/native'

import { useCustomSafeInsets } from 'ui/theme/useCustomSafeInsets'

const TabBarSpacer: React.FC = () => {
  const { tabBarHeight } = useCustomSafeInsets()
  const { showTabBar } = useTheme()
  return <CustomHeightSpacer customHeight={tabBarHeight} enable={showTabBar} />
}

const TopScreenSpacer: React.FC = () => {
  const { top } = useCustomSafeInsets()
  return <CustomHeightSpacer customHeight={top} enable />
}

const BottomScreenSpacer: React.FC = () => {
  const { bottom } = useCustomSafeInsets()
  return <CustomHeightSpacer customHeight={bottom} enable />
}

const CustomHeightSpacer = styled.View<{ customHeight: number; enable?: boolean }>(
  ({ customHeight, enable }) => ({
    height: enable ? customHeight : 0,
  })
)

export const Spacer = {
  TopScreen: TopScreenSpacer,
  TabBar: TabBarSpacer,
  BottomScreen: BottomScreenSpacer,
}
